import { CalendarClock, CheckCircle2, Clock, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

const STATES = {
  action: {
    Icon: CheckCircle2,
    color: "text-emerald-500",
    heading: "All caught up!",
    description: "No follow-ups need your attention right now.",
    cta: null,
  },
  scheduled: {
    Icon: CalendarClock,
    color: "text-navy",
    heading: "Nothing scheduled",
    description: "Schedule a follow-up to keep leads engaged.",
    cta: "Schedule Follow-up",
  },
  completed: {
    Icon: CheckCircle2,
    color: "text-emerald-500",
    heading: "No completed follow-ups yet",
    description: "Completed follow-ups will appear here after you mark them done.",
    cta: null,
  },
  all: {
    Icon: Inbox,
    color: "text-navy/40",
    heading: "No follow-ups yet",
    description: "Get started by scheduling your first follow-up.",
    cta: "Schedule Follow-up",
  },
};

export default function FollowUpEmptyState({ tab = "all", onSchedule }) {
  const state = STATES[tab] || STATES.all;
  const { Icon, color, heading, description, cta } = state;

  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-navy/10 bg-white py-16 text-center">
      <div className={`mb-4 rounded-full bg-navy/5 p-4 ${color}`}>
        <Icon className="h-8 w-8" />
      </div>
      <h3 className="font-display text-lg font-semibold text-navy">{heading}</h3>
      <p className="mt-1 max-w-xs text-sm text-muted-foreground">{description}</p>
      {cta && onSchedule && (
        <Button
          onClick={onSchedule}
          className="mt-5 bg-navy text-white hover:bg-navy-hover"
        >
          <Clock className="mr-2 h-4 w-4" />
          {cta}
        </Button>
      )}
    </div>
  );
}
